import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import AddCompanyModal from "../../components/construction/AddCompanyModal"
import useUser from "../../hooks/useUser"
import { useSelectedCompany } from "../../context/companyProvider"
import { ManagementCompany } from "../../Interfaces"
import { t } from "../../i18n"
import { managementCompanyService } from "../../services/managementCompanyService"
import CompaniesPageView from "./CompaniesPageView"

export default function CompaniesPage() {
  const { id } = useUser()
  const { selectCompany } = useSelectedCompany()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [modalOpen, setModalOpen] = useState(false)

  const { data: companies = [], isLoading, error } = useQuery<ManagementCompany[]>(
    ["managementCompanies", id],
    () => managementCompanyService.listForUser(id),
    {
      enabled: !!id,
      suspense: false,
      useErrorBoundary: false,
    },
  )

  const handleCreated = (company: ManagementCompany) => {
    queryClient.setQueryData<ManagementCompany[]>(
      ["managementCompanies", id],
      (current) => [company, ...(current || []).filter((row) => row.id !== company.id)],
    )
  }

  const handleSelect = (company: ManagementCompany) => {
    selectCompany(company)
    navigate("/app/locations")
  }

  return (
    <>
      <CompaniesPageView
        companies={companies}
        isLoading={isLoading}
        error={error ? t("companies.loadFailed") : null}
        onAdd={() => setModalOpen(true)}
        onSelect={handleSelect}
      />
      <AddCompanyModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreated={handleCreated}
      />
    </>
  )
}
